import { Component, OnInit } from '@angular/core';
import { AutocompleteNode } from '../../common/ceq-unit-autocomplete/ceq-unit-autocomplete.component';
import Swal from 'sweetalert2';

import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import { MultichannelService } from '../multichannel.service';
import { SettingsService } from '../../../core/settings/settings.service';
import { CeveService } from "../../catalog/ceve/ceve.service";
import { OrgService } from '../../catalog/org/org.service';

import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Route } from 'src/app/ceq/common/models/Route.Model';
import { Org } from "src/app/ceq/common/models/Org.Model";

interface Channel {
  UnitId: number;
  ChannelCode: string;
  ChannelId: number;
  ChannelName: string;
}

interface AdjustList {
  RouteId: number;
  Item: string;
  OldQty: number;
  NewQty: number;
}

@Component({
  selector: 'app-adjust-load-order',
  templateUrl: './adjust-load-order.component.html',
  styleUrls: ['./adjust-load-order.component.scss']
})
export class AdjustLoadOrderComponent implements OnInit {

  constructor(
    private settingsService: SettingsService,
    private globalService: GlobalFunctionsService,
    private multiService: MultichannelService,
    private ceveService: CeveService,
    private orgServ: OrgService
  ) { }

  userLogin: UserLogin;
  userCeves: number[];

  ceveNode: AutocompleteNode;
  initialNode: AutocompleteNode;
  channelList: Channel[] = [];
  routes: Route[] = [];
  loadData: any[] = [];
  baseLoadData: any[] = [];
  cols: string[] = [];
  listAdjust: AdjustList[] = [];
  activities: string[];

  selectedRoute: number;
  selectedChannel: string;
  selectedChannelId: number = 0;
  noRoute: boolean = false;
  org: Org[] = [];
  orgId: number = 0;

  working: boolean = false;
  saving: boolean = false;
  currentDate: Date;
  selectedDate: string;
  firstDate: string;
  nextOneDate: string;
  nextTwoDate: string;
  filtered: boolean = false;
  loading: boolean = false;
  canGetCargo: boolean = false;
  enableCargo: boolean = true;

  loadingRoutesLoadStatus: boolean = false;
  hasroutesRejected: boolean = false;
  routesRejected: any[] = [];
  adjustAS: boolean = false;

  ngOnInit(): void {
    this.currentDate = new Date();
    this.selectedDate = this.globalService.getStringDate(this.currentDate, false, 0);
    this.firstDate = this.selectedDate;
    this.currentDate.setDate(this.currentDate.getDate() + 1);
    this.nextOneDate = this.globalService.getStringDate(this.currentDate, false, 0);
    this.currentDate.setDate(this.currentDate.getDate() + 1);
    this.nextTwoDate = this.globalService.getStringDate(this.currentDate, false, 0);
    this.userLogin = this.settingsService.getUser();
    this.getOrg();
  }

  //Gets the list of organizations
  getOrg() {
    this.loading = true;
    this.orgServ.getActiveOrgs().subscribe(data => {
      this.org = data;
      this.orgId = this.userLogin.OrgId
    });
  }

  /**
   * Changes data grid filtering the data by the received argument and validates if the country is selected to apply extra filter
   *
   * @param {*} event - Filter received from DOM
   * @memberof RegionListComponent
   */
  changeFilterOrg(event: any): void {
    this.orgId = event;
  }

  // Evento cuando se limpia el combo de centro de ventas
  setOutputNode(event: any) {
    this.ceveNode = event;
    this.noRoute = false;
    this.getLoadData();
    this.getChannels();
  }

  // Evento cuando se limpia el combo de centro de ventas
  clearOutputNode() {
    this.ceveNode = this.initialNode;
    this.loadData = [];
    this.baseLoadData = [];
  }

  /**
   * Obtiene los canales de venta asignados al centro de venta
   */
  getChannels() {
    this.channelList = [];
    this.ceveService.getChannelsbyCeve(this.ceveNode.UnitId).subscribe(data => {
      this.channelList = data;
      if (data.length > 0) {
        this.selectedChannelId = 0;
        this.selectedChannel = '0';
        this.getRoutes();
      } else {
        this.enableCargo = false;
        this.noRoute = true;
        this.globalService.messageToast('No se encontraron canales asignados al centro de venta.', 'warning');
        console.log('No se encontraron canales');
      }
    });
  }

  /**
   * Permite obtener las rutas del canala seleccionado
   * @param channelid 
   */
  changeChannel() {
    this.getRoutes();
  }

  /**
   * Permite cambiar la fecha de carga de las rutas
   */
  changeDate() {
    this.getLoadData();
  }

  // Obtiene las rutas del canal seleccionado
  getRoutes() {
    if (this.selectedChannel != '0') {
      this.selectedChannelId = this.channelList.find(x => x.ChannelCode == this.selectedChannel).UnitId;
    }
    this.ceveService.getCeveRoutes(this.ceveNode.UnitId, this.selectedChannelId).subscribe(data => {
      this.routes = data;
      if (data != null) {
        this.selectedRoute = 0;
        if (this.baseLoadData.length > 0) {
          this.filterChannel();
        } else {
          this.getLoadData();
        }
      }
      else {
        this.selectedRoute = null;
      }
    }, (error) => { }
      , () => { this.cmbRouteChange() });
  }

  // Filtra la tabla de rutas con la seleccionada
  cmbRouteChange() {
    this.filterRoutes();
  }

  // Obtiene los datos de carga de las rutas
  async getLoadData() {
    this.loading = true;
    await this.multiService.getRouteDataLoad(this.ceveNode.UnitId, this.selectedDate).toPromise().then(resp => {
      if (resp.Data.length > 0) {
        resp.HasCargos=true;
        this.enableCargo = resp.HasCargos;
        this.baseLoadData = resp.Data;
        this.loadData = resp.Data;
        this.cols = Object.keys(resp.Data[0]);
        this.cols = this.cols.filter(x => x != 'RUTA_ID' && x != 'CANAL');
        //console.log(this.cols);
        this.loading = false;
      } else {
        this.enableCargo = false;
        this.loading = false;
        this.globalService.messageToast(`No se encontraron cargos en este ceve.`, 'warning');
      }
    });

    await this.getroutesLoadStatus();
  }

  // Método que filtra las rutas
  filterRoutes() {
    if (this.filtered == false) {
      if (this.selectedRoute == 0) {
        this.loadData = this.baseLoadData;
      } else {
        this.loadData = this.baseLoadData.filter(x => x.RUTA_ID == this.selectedRoute);
        let route = this.routes.find(x => x.RouteId == this.selectedRoute);
        this.selectedChannel = route.ChannelCode;
      }
    }
    this.filtered = false;
    this.getroutesLoadStatus();
  }

  // Método que filtrar la tabla de rutas con el canal seleccionado
  filterChannel() {
    this.filtered = true;
    if (this.selectedChannel == '0') {
      this.loadData = this.baseLoadData;
    } else {
      this.loadData = this.baseLoadData.filter(x => x.CANAL == this.selectedChannel);
    }
  }

  /**
   * Agrega un ajuste a la lista de ajustes
   * @param row 
   * @param item 
   * @param qty 
   * @returns 
   */
  putAdjust(row: any, item: any, qty: number) {
    /*if(row.CANAL == '561'){
      this.globalService.messageToast('No se puede hacer ajuste en rutas de Autoservicios.', 'warning');
      row[item] = 0;
      this.adjustAS = true;
      return;
    }*/
    let exist = this.listAdjust.find(x => x.RouteId == row.RUTA_ID && x.Item == item);
    if (exist != null) {
      exist.NewQty = qty;
    } else {
      this.listAdjust.push({
        RouteId: row.RUTA_ID,
        Item: item,
        OldQty: row[item],
        NewQty: qty
      });
    }
    //console.log(row, item, qty,row[item]);
  }

  /**
   * Envia a guardar los datos de ajustes
   */
  saveData() {
    let msg: string = '...espere un momento.';
    if(this.adjustAS == true){
      msg = 'No se registrarán ajustes en rutas de Autoservicios.<br> ...espere un momento.';
    }
    if (this.listAdjust.length > 0) {
      this.saving = true;
      // Swal.fire({
      //   title: 'Guardando datos...',
      //   html: msg,
      //   allowOutsideClick: false,
      //   didOpen: () => {
      //     Swal.showLoading()
      //   }
      // });
      this.globalService.messageBimbo('Por Favor Espere...', 'loading','Guardando datos...');

      this.multiService.saveRouteLoad(this.ceveNode.UnitId, this.selectedDate, this.listAdjust).subscribe(resp => {
        this.saving = false;
        this.getLoadData();
        this.filterChannel();
        Swal.close();
        this.globalService.messageToast('Datos guardados correctamente', 'success');
        this.listAdjust = [];
      }, (error) => {
        this.saving = false;
        Swal.close();
        this.globalService.messageToast('Error al guardar los datos', 'error');
      });
    }
  }

  // Se obtienen los cargos de forma manual
  getCharge() {
    this.multiService.getChargeRoutes(this.ceveNode.UnitId, this.selectedDate).subscribe(resp => {
      console.log(resp);
      this.enableCargo = true;
      this.getLoadData();
      this.globalService.messageToast('Datos cargados correctamente', 'success');
    }, (error) => {
      this.enableCargo = false;
      this.globalService.messageToast('Error al obtener los cargos', 'error');
    });
  }

  async getroutesLoadStatus() {
    this.routesRejected = [];
    let currentStringDate = this.globalService.getStringDate(new Date(), false, 0);
    if (currentStringDate != this.selectedDate) {
      this.hasroutesRejected = false;
    }
    else {
      let routeIds = [this.selectedRoute];

      this.loadingRoutesLoadStatus = true;
      await this.multiService.getRoutesLoadStatus(this.ceveNode.UnitId, routeIds).toPromise().then((resp: any[]) => {
        this.loadingRoutesLoadStatus = false;
        this.hasroutesRejected = resp.length > 0;
        this.routesRejected = resp;
        console.log('routes rejected', resp);
      }).catch((error) => {
        console.error(error);
      });

    }
  }

}
